import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import { Chip } from '@app/core';
import { GenericInput } from '@app/form';
import classnames from 'classnames';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    padding: 0,
    paddingLeft: 10,
    overflow: 'hidden',
  },
  input: {
    border: 'none',
    outline: 'none',
    textAlign: 'right',
    flex: 1,
    fontSize: '1rem',
    '&::-webkit-outer-spin-button': {
      display: 'none',
    },
    '&::-webkit-inner-spin-button': {
      display: 'none',
    },
    '-moz-appearance': 'textfield',
  },
  unit: {
    color: theme.colors.inkTertiary,
    whiteSpace: 'nowrap',
    backgroundColor: theme.colors.grayBackground,
    borderLeft: `1px solid ${theme.colors.grayBorder}`,
    fontWeight: 400,
    padding: [[6, 12]],
    display: 'flex',
    alignItems: 'center',
    height: theme.height.small,
  },
}));

interface Props {
  label: string;
  value: number | '';
  onChange: (value: number) => void;
}

export const InputContent = ({
  value,
  onChange,
  chipLabel,
  className,
}: {
  value: number | '';
  onChange: (value: number) => void;
  chipLabel: string;
  className?: string;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classnames(classes.container, className)}>
      <Chip color="blue">{chipLabel ? t(chipLabel) : ''}</Chip>
      <input
        type="number"
        placeholder="ex: 30"
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          onChange(val === '' ? 0 : parseInt(val));
        }}
        className={classes.input}
      />
      <div className={classes.unit}>
        {t('editSession.targeting.quotas.unit')}
      </div>
    </div>
  );
};

export const QuotaInput = ({ label, value, onChange }: Props) => {
  return (
    <GenericInput
      small
      noMargin
      value={value}
      component={InputContent}
      chipLabel={label}
      onChange={onChange}
    />
  );
};
